//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import { SessionVarsService as ISessionVarsService } from '@services/session-vars-service';
import {
    INSTAGRAM_DASHBOARD_HASHTAG_PAGE_LINK,
    LIBRARY_HASHTAG_PAGE_LINK,
} from '@streams-drawer/model/content-detail-links';
import { getUserHref } from '@streams-drawer/streams-drawer-constants';
import { InstagramWebLinks } from 'app/constants/social-links';

import template from './streams-drawer-grid-item.html';
import './streams-drawer-grid-item.less';

class StreamsDrawerGridItem {
  public isShareV2Vendor;
  public item;
  public hrefHandlers;
  public userHref;
  public network;

  public constructor(private SessionVarsService: ISessionVarsService) {}

  public $onInit() {
    this.hrefHandlers = {
      user: ({ name }) => getUserHref(name, this.network),
      // Always link Curalate Connect clients to Instagram.com because they
      // don't have access to the rest of the Curalate Webapp
      hashtag: ({ id }) => {
        if (this.isShareV2Vendor) {
          return InstagramWebLinks.getHashtagLink(id);
        } else {
          return INSTAGRAM_DASHBOARD_HASHTAG_PAGE_LINK(id);
        }
      },
    };

    const username = this.item?.socialDetails?.user?.username;
    this.network = this.item?.socialDetails?.network;
    this.userHref = getUserHref(username, this.network);
  }
}

angular.module('curalate').component('streamsDrawerGridItem', {
  controller: [
    'SessionVarsService',
    StreamsDrawerGridItem,
  ],
  bindings: {
    isShareV2Vendor: '<',
    item: '<',
    shouldShowGalleryText: '<',
    shouldShowConnectText: '<',
    disableBulkActions: '<',
  },
  template,
});
